<template>
  <div id="drawarea">
    <t-drawer :attach="'body'" :onClose="handClose" v-model:visible="visible" size="100%" header="" :footer="false"
      :close-btn="true">
      <div style="height: 100%;">
        <div id="_container" ref="container"></div>
        <ul class="drawing-panel" style="z-index: 99">
          <li class="btn" @click="openEdit">编辑</li>
          <li class="btn" @click="confirmEdit">确定</li>
          <li class="btn" @click="deleteEdit">删除</li>
          <li class="btn" @click="closeEdit">关闭</li>
        </ul>
      </div>
    </t-drawer>
    <div style="
        width: 100%;
        height: 100%;
        border: none;
        text-align: center;
        padding:10px;
        cursor: pointer;
      " @click="handleClick" :style="{
        background: option.attribute.bgColor,
        color: option.attribute.textColor,
        lineHeight: height + 'px',
        borderRadius: option.attribute.radius + 'px',
      }">
      绘制区域
    </div>
  </div>
</template>

<script setup>
import {
  getDataJson,
  pollingRefresh,
  getDefaultValue,
  hasNonEmptyValues,
  hasProperty,
} from "@/utils/refresh-cpt-data";
import { reactive, ref, getCurrentInstance, watch, provide, onMounted, defineEmits, computed } from "vue";
import { useRoute } from "vue-router";
// import DrawArea from "@/views/baidu/DrawArea";
import { MessagePlugin } from "tdesign-vue-next";
// import loadBMap from '@/utils/baiduMap.js' //单个文件加载百度地图
let map = ref(null);
let arr = ref([]);
let marker = ref(null)
let polygon = ref(null)
const visible = ref(false);
const route = useRoute();
const container = ref(null);
const currentRoute = route.name;
const emit = defineEmits(['clickHandler'])
const props = defineProps({
  option: Object,
  current: Object,
});
let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
let scaleValue = ref('')
// var nodeT = new BMapGL.Icon(
//   "//mapopen-pub-jsapigl.bj.bcebos.com/demoimg/ditie_beijing_2.png",
//   new BMapGL.Size(11, 11),
//   {
//     offset: new BMapGL.Size(5, 5),
//   }
// );
// var node = new BMapGL.Icon(
//   "//mapopen-pub-jsapigl.bj.bcebos.com/demoimg/zhongheyiyuan.png",
//   new BMapGL.Size(11, 11),
//   {
//     offset: new BMapGL.Size(5, 5),
//   }
// );
let openEdit = () => {
  polygon.value.enableEditing();
};
let confirmEdit = () => {
  let dataToPass = [];
  polygon.value.disableEditing();
  var path = polygon.value.getPath()
  for (var i = 0; i < path.length; i++) {
    var point = path[i];
    console.log('[' + point.lng + ', ' + point.lat + ']');
    dataToPass.push('[' + point.lng + ', ' + point.lat + ']')
  }
  cptData.value = '[' + dataToPass.join(',') + ']'
  console.log(cptData, "5555555555")
  console.log(path, "6666666666")
  emit("clickHandler", props.option.interaction, 'default', cptData.value, 'cpt-drawarea')
}
let closeEdit = () => {
  visible.value = false
  // setTimeout(function (){
  //     var element = document.getElementById("scaleDiv")
  //         console.log("bidfddfdf")
  //         console.log(element)
  //     if (element) {
  //         element.style.transform = scaleValue.value;
  //       }
  // },260)

};

let deleteEdit = () => {
  map.value.clearOverlays();

};
let handClose = () => {
  visible.value = false
  // setTimeout(function (){
  // var element = document.getElementById("div"+ props.current.id)
  // if (element) {
  //     element.style.transform = scaleValue.value;
  //   }
  // },260)
}
const initMap = () => {
  let centerx = props.option.attribute.centerx;
  let centery = props.option.attribute.centery;
  let zoom = props.option.attribute.zoom;
  map.value = new BMapGL.Map(container.value); // 创建Map实例
  // console.log(map.value,'map')
  map.value.centerAndZoom(new BMapGL.Point(centerx, centery), zoom); // 初始化地图,设置中心点坐标和地图级别
  map.value.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
  marker.value = new BMapGL.Marker(new BMapGL.Point(centerx, centery)); // 创建标注
  map.value.addOverlay(marker.value); // 将标注添加到地图中
  console.log('cptData.value', cptData.value)
  let coordinates = JSON.parse(cptData.value).map(point => point.map(Number));
  console.log('coordinates', coordinates)
  for (let i = 0; i < coordinates.length; i++) {
    arr.value.push(new BMapGL.Point(coordinates[i][0], coordinates[i][1]))
  }
  polygon.value = new BMapGL.Polygon(
    arr.value,
    {
      zIndex: 10,
      node: new BMapGL.Icon(
        require('@/assets/map/zhongheyiyuan.png'),
        new BMapGL.Size(11, 11),
        {
          offset: new BMapGL.Size(5, 5),
        }
      ),
      nodeT: new BMapGL.Icon(
        require('@/assets/map/ditie_beijing_2.png'),
        new BMapGL.Size(11, 11),
        {
          offset: new BMapGL.Size(5, 5),
        }
      ),
      strokeStyle: "dashed",
      fillColor: "#3d4757",
      fillOpacity: 0.5,
      strokeColor: "blue",
      strokeWeight: 2,
      strokeOpacity: 1,
    }
  );
  map.value.addOverlay(polygon.value);


  if (props.option.attribute.isOpen == 1) {
    handleClick()
  }
}
watch(() => props.current.cptShow, (val) => {
  if (val && dataReload.value.includes(1)) {
    refreshCptData();
  }
})
watch(() => props.option.attribute.hideCompInTabw, (val) => {
  if (!val && dataReload.value.includes(1)) {
    refreshCptData();
  }
})
onMounted(async () => {
  // setTimeout(()=>{
  //     initMap()
  //   },800)
  if (dataReload.value.includes(0)) {
    refreshCptData();
  }
  // await loadBaiduMap();

});

const getValue = () => {
  return cptData?.value
};
const setValue = (value) => {
  console.log('setValue', value)
  cptData.value = value
};

const handleClick = () => {
  if (currentRoute != "design") {
    visible.value = true;
    map.value.addOverlay(polygon.value);
    map.value.addOverlay(marker.value);
    var element_two = document.getElementById("_container")
    element_two.style.transform = 'scaleX(1.2) scaleY(1.2)';
    //var element = document.getElementById("scaleDiv")
    //   var element = document.getElementById("div"+ props.current.id)
    //   scaleValue.value = element.style.transform
    //  if (element && element.style.transform) {
    //   // 删除内联样式 transform
    //    element.style.transform = '';
    //   }
  }
};
//uuid 必须
let uuid = require("uuid").v1();
//自定义组件值接收字段
let cptData = reactive({});
let newData = reactive({});
let jsFunFlag = ref(false);

//refreshCptData固定写法，必须！
const refreshCptData = () => {
  pollingRefresh(uuid, props.option.cptDataForm, loadData);
};
//自定义数据处理方法
const loadData = () => {
  getDataJson(props.option.cptDataForm, "", (res) => {
    //res为数据表单的静态数据或执行API返回的数据
    newData =
      props.option.cptDataForm.dataSource == "4" &&
        hasProperty(res, "jsFunction")
        ? res.resStr
        : res; //相同数据集只调用一次接口原因
    jsFunFlag.value =
      props.option.cptDataForm.dataSource == "4" &&
        hasProperty(res, "jsFunction")
        ? res.jsFunction
        : false; //相同数据集只调用一次接口原因
    processData(props.option.cptDataForm, newData, jsFunFlag.value);
  });
};
const processData = (cptDataForm, res, jsFunFlag, isFromGrid) => {
  // 第一层判断 如果选择数据集
  if (cptDataForm.dataSource == "4") {
    if (props.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid') {
      return
    }
    // 第二层判断 ，如果没有配转换脚本
    if (jsFunFlag) {

      // 没有全部配置映射字段
      let arr = JSON.parse(JSON.stringify(props.option.attribute.cptTableData));
      console.log(hasNonEmptyValues(arr));
      if (hasNonEmptyValues(arr)) {
        let arrData = []
        res.forEach(element => {
          if (element.ISCENTERPOINT !== 1) {
            arrData.push(element.GPS)
          }
        });
        // 把中心坐标点放在数组的第一项前
        res.forEach(element => {
          if (element.ISCENTERPOINT == 1) {
            arrData.unshift(element.GPS)
          }
        });
        // let pointsArray = arrData.map(pointStr => {
        //   let pointParts = pointStr.slice(1, -1).split(','); // 去掉 [] 并按逗号分割
        //   console.log(pointParts,'pointPartspointPartspointParts')
        //   return pointParts.map(parseFloat); // 将字符串转换为浮点数
        // });
        console.log(arrData,'pointsArray')
        // let stringifiedArray = JSON.stringify(pointsArray);
        // console.log(11111)
        // console.log(stringifiedArray)
        cptData.value = arrData[0]
      }
    } else {
      // 如果配置了转换脚本已经处理好了的数据,直接赋值
      console.log('asdasdfffffffff')
      cptData.value = res;
    }
  } else {
    // 不是数据集类型，是静态数据
    Object.assign(cptData, res);

  }

  initMap();

};
const loadBaiduMap = async () => {
  await loadBMap('7fFqz1bKk5DPlq2GIXr4bOLCUgKyyXID'); // 替换为实际的AK值
}
watch(
  props.option.attribute,
  () => {
    processData(props.option.cptDataForm, newData, jsFunFlag.value);
  },
  {
    deep: true,
  }

);

//初始化数据，可选。echarts类组件需要放在onMounted中执行！

//暴露refreshCptData，必须！
defineExpose({ refreshCptData, getValue, setValue, current: props.current });
</script>


<style scoped>
:deep(.t-drawer__footer) {
  padding: 0 0 !important;
}

:deep(.t-drawer__close-btn) {
  z-index: 10000;
}

:deep(.t-drawer__close-btn) {
  background: #f5f5f5;
  color: #000;
  position: absolute;
  right: 0rem;
  opacity: 0.3;
  font-weight: bold;
  top: 0rem;
}

:deep(.t-drawer__close-btn:hover) {
  background: #f5f5f5;
  color: #000;
  position: absolute;
  right: 0rem;
  opacity: 0.4;
  font-weight: bold;
  top: 0rem;
}

:deep(.t-drawer__close-btn .t-icon) {
  font-size: 25px;
}



#_container {
  overflow: hidden;
  width: 100%;
  height: 100%;
  margin: 0;
  font-family: "微软雅黑";
}

ul li {
  list-style: none;
}

.drawing-panel {
  z-index: 9;
  position: absolute;
  top: 2rem;
  right: 1rem;
  padding: 0.5rem 0.5rem;
  border-radius: 0.25rem;
  background-color: #fff;
  box-shadow: 0 2px 6px 0 rgba(27, 142, 236, 0.5);
}

.btn {
  width: 35px;
  height: 30px;
  /* float: left; */
  background-color: #fff;
  color: rgba(27, 142, 236, 1);
  font-size: 14px;
  border: 1px solid rgba(27, 142, 236, 1);
  border-radius: 5px;
  /* margin: 0 5px; */
  margin: 2px 0;
  text-align: center;
  line-height: 30px;
}

.btn:hover {
  background-color: rgba(27, 142, 236, 0.8);
  color: #fff;
}
</style>